export const SERVER_DATA_SUBSCRIBED = 'SERVER/SERVER_DATA_SUBSCRIBED';
export const SERVER_DATA_CHANGED = 'SERVER/SERVER_DATA_CHANGED';

export const PUBLIC_DATA_SUBSCRIBED = 'SERVER/PUBLIC_DATA_SUBSCRIBED';
export const PUBLIC_DATA_RECEIVED = 'SERVER/PUBLIC_DATA_RECEIVED';
